import CanvasFunctions from './canvas-functions';
import Util from './util';

// Swapping the image moves its opaque bounds, so a cropped item needs re-fitting.
export default function applyNoBgImageChange(shared, item) {
  const oldWidth = item.e.width;
  const oldHeight = item.e.height;
  const wasCropped = Util.isDefined(oldWidth) && Util.isDefined(oldHeight);

  if (!wasCropped) {
    item.e.width = null;
    item.e.height = null;
    item.e.cropScale = undefined;
  } else {
    shared.ensureImageData(item);
    const imgData = item.e.noBgImage ? item.noBgImageData : item.originalImageData;
    const tmpCanvas = CanvasFunctions.convertImageDataToCanvasImageSource(imgData);
    if (item.e.backgroundRemovalMode === 'simple') {
      CanvasFunctions.simpleRemoveBackground(
        tmpCanvas,
        item.e.backgroundColor,
        item.e.backgroundColorRange
      );
    }
    const autoCrop = CanvasFunctions.getAutoCropData(tmpCanvas);
    const cropScale = item.e.cropScale || 1;

    if (item.e.noBgImage) {
      // update crop to fit image
      const cropLeft = item.e.cropLeft || 0;
      const cropTop = item.e.cropTop || 0;
      const cropRight = cropLeft + oldWidth / cropScale;
      const cropBottom = cropTop + oldHeight / cropScale;

      const newLeft = Math.max(cropLeft, autoCrop.left);
      const newTop = Math.max(cropTop, autoCrop.top);
      const newRight = Math.min(cropRight, autoCrop.left + autoCrop.width);
      const newBottom = Math.min(cropBottom, autoCrop.top + autoCrop.height);

      item.e.cropLeft = newLeft;
      item.e.cropTop = newTop;
      item.e.width = Math.max(0, newRight - newLeft) * cropScale;
      item.e.height = Math.max(0, newBottom - newTop) * cropScale;
    } else {
      // the refit above only ever shrinks, so clearing the cutout re-fits the whole image
      item.e.cropLeft = autoCrop.left;
      item.e.cropTop = autoCrop.top;
      item.e.width = autoCrop.width * cropScale;
      item.e.height = autoCrop.height * cropScale;
    }
  }

  const previousVisibility = item.style.visibility;
  item.style.visibility = 'hidden';

  return shared
    .drawItem(item, item.e)
    .then(() => {
      const newWidth = item.e.width;
      const newHeight = item.e.height;
      item.e._objProps.realX += (oldWidth - newWidth) / 2;
      item.e._objProps.realY += (oldHeight - newHeight) / 2;

      shared.finishAddingItem({
        item,
        props: item.e,
        selectItem: item.classList.contains('selected'),
        updateSingleItemZoomRatio: true,
      });
    })
    .finally(() => {
      if (item.style.visibility === 'hidden') {
        item.style.visibility = previousVisibility;
      }
    });
}
